import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { fetchAccountOverview } from '../store/actions/account-actions';

import Header from './Header';
import CopyrightAndVersion from '../components/CopyrightAndVersion';
import PersonalDetails from './PersonalDetails';
import UserAccounts from './UserAccounts';

const Account = () => {
  const { showUserAccounts } = useSelector(
    (state) => ({
      showUserAccounts:
        state.auth.tokenPayload &&
        state.auth.tokenPayload.scopes &&
        state.auth.tokenPayload.scopes.indexOf('manage:users') > -1,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAccountOverview());
  });

  return (
    <div className="Account">
      <Header />
      <div className="Account_top">
        <div className="container">
          <h1>Account Overview</h1>
        </div>
      </div>
      <PersonalDetails />
      <div className="Account_divider" />
      {showUserAccounts && <UserAccounts />}
      <CopyrightAndVersion />
    </div>
  );
};

export default Account;
